import { useEffect, useState } from "react";
import { liveServerUrl, serverUrl } from "../../Shared/constant";



export const useOrderCount = () => {
    const [count, setCount] = useState(0);

    useEffect(() => {
        fetch(`${serverUrl}/api/mosollaLanding`)
            .then((response) => response.json())
            .then((result) => {
                setCount(result.length);
            })
            .catch((error) => console.error("Error:", error));
    }, []);

    console.log('heelo', count)
    return count;
};